import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import ReactPaginate from "react-paginate";
import styled from "styled-components";
import apiConfig from '../apiConfig';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";

const Daily_deposit = () => {
  const [data, setData] = useState([]);
  const [limit, setLimit] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalBonus, setTotalBonus] = useState(0);
  const [statusFilter, setStatusFilter] = useState("paid");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [userIdSearch, setUserIdSearch] = useState("");
  const currentPage = useRef(1);

  useEffect(() => {
    getPaginatedUsers();
  }, [limit, startDate, endDate, statusFilter]);

  const handlePageClick = (e) => {
    currentPage.current = e.selected + 1;
    getPaginatedUsers();
  };

  const handleApprovePayment = async (depositId, event) => {
    event.preventDefault();
    try {
      const response = await axios.post(`${apiConfig.baseURL}/api/agent/user_transfer_update`, { depositId });
      getPaginatedUsers();
      alert(response.data.message);
    } catch (error) {
      console.error('Error approving payment:', error);
      alert('Error approving payment: ' + error.message);
    }
  };

  const handleRejectPayment = async (depositId, event) => {
    event.preventDefault();
    try {
      const response = await axios.post(`${apiConfig.baseURL}/api/agent/user_transfer_reject`, { depositId });
      getPaginatedUsers();
      alert(response.data.message);
    } catch (error) {
      console.error('Error rejecting payment:', error);
      alert('Error rejecting payment: ' + error.message);
    }
  };

  const getPaginatedUsers = async () => {
    const formattedStartDate = startDate ? startDate.toISOString() : "";
    const formattedEndDate = endDate ? endDate.toISOString() : "";
    try {
      const response = await axios.get(`${apiConfig.baseURL}/api/agent/daily_deposit`, {
        params: {
          user_id: userIdSearch.trim() || undefined,
          page: currentPage.current,
          limit: limit,
          status: statusFilter === 'all' ? undefined : statusFilter,
          startDate: formattedStartDate,
          endDate: formattedEndDate,
        }
      });

      if (response.status === 200) {
        const resData = response.data;
        setPageCount(resData.pageCount);
        setTotalUsers(resData.totalUsers);
        setTotalAmount(resData.totalAmount);
        setTotalBonus(resData.totalBonus);
        setData(resData.result);
      }
    } catch (error) {
      console.error('Error fetching paginated users:', error);
      alert('Error fetching paginated users: ' + error.message);
    }
  };

  const clearFilters = () => {
    setUserIdSearch("");
    setStartDate(null);
    setEndDate(null);
    setStatusFilter("paid");
    setLimit(10);
    currentPage.current = 1;
    getPaginatedUsers();
  };

  const handleSearch = () => {
    currentPage.current = 1;
    getPaginatedUsers();
  };

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const options = { hour: 'numeric', minute: 'numeric', hour12: true };
    const timeString = date.toLocaleString('en-US', options);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${timeString.toLowerCase()} ${day}/${month}/${year}`;
  };

  const MyPaginate = styled(ReactPaginate).attrs({ activeClassName: "active" })`
    margin-bottom: 2rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    list-style-type: none;
    padding: 0 2rem;
    li a {
      border-radius: 7px;
      padding: 0.1rem 1rem;
      border: gray 1px solid;
      cursor: pointer;
      margin: 0 5px;
    }
    li.active a { background-color: #0366d6; color: white; }
    li.disabled a { color: grey; background-color: #26B19B !important; }
  `;

  return (
    <>
      <Navbar />
      <Chatbox />
      <HeaderRight />
      <LeftSidebar />

      <div className="content-body">
        <div className="container-fluid">
          <div className="col-lg-12">

          <div className="row g-2 mb-2">

              <div className="col-6 col-md-3">
                <div className="card text-white bg-success">
                  <div className="card-body py-1 px-2 d-flex justify-content-between align-items-center">
                    <div>
                      <small className="d-block" style={{ fontSize: "11px" }}>Total (filtered)</small>
                      <div style={{ fontSize: "14px", fontWeight: "600" }}>
                        ৳{totalAmount.toLocaleString('en-US')}
                      </div>
                    </div>
                    <i className="fa fa-money" style={{ fontSize: "18px", opacity: 0.7 }}></i>
                  </div>
                </div>
              </div>

              <div className="col-6 col-md-3">
                <div className="card text-white bg-info">
                  <div className="card-body py-1 px-2 d-flex justify-content-between align-items-center">
                    <div>
                      <small className="d-block" style={{ fontSize: "11px" }}>Bonus (filtered)</small>
                      <div style={{ fontSize: "14px", fontWeight: "600" }}>
                        ৳{totalBonus.toLocaleString('en-US')}
                      </div>
                    </div>
                    <i className="fa fa-gift" style={{ fontSize: "18px", opacity: 0.7 }}></i>
                  </div>
                </div>
              </div>

              <div className="col-6 col-md-3">
                <div className="card text-white bg-warning">
                  <div className="card-body py-1 px-2 d-flex justify-content-between align-items-center">
                    <div>
                      <small className="d-block" style={{ fontSize: "11px" }}>Page</small>
                      <div style={{ fontSize: "14px", fontWeight: "600" }}>
                        {currentPage.current} / {pageCount}
                      </div>
                    </div>
                    <i className="fa fa-calendar" style={{ fontSize: "18px", opacity: 0.7 }}></i>
                  </div>
                </div>
              </div>

              <div className="col-6 col-md-3">
                <div className="card text-white bg-primary">
                  <div className="card-body py-1 px-2 d-flex justify-content-between align-items-center">
                    <div>
                      <small className="d-block" style={{ fontSize: "11px" }}>Records (filtered)</small>
                      <div style={{ fontSize: "14px", fontWeight: "600" }}>
                        {totalUsers}
                      </div>
                    </div>
                    <i className="fa fa-list" style={{ fontSize: "18px", opacity: 0.7 }}></i>
                  </div>
                </div>
              </div>

            </div>

            <div className="card">
              <h4 className="card-title">Daily Deposit Report</h4>

              <div className="card-header py-2">
                  <div className="row g-2 align-items-end">

                    {/* User ID Search */}
                    <div className="col-12 col-md-3">
                      <small className="d-block mb-1">User ID</small>
                      <div className="input-group input-group-sm">
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Search..."
                          value={userIdSearch}
                          onChange={(e) => setUserIdSearch(e.target.value)}
                          onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                        />
                        <button className="btn btn-primary btn-sm" onClick={handleSearch}>
                          Go
                        </button>
                      </div>
                    </div>

                    {/* Start Date */}
                    <div className="col-6 col-md-2">
                      <small className="d-block mb-1">Start</small>
                      <DatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        placeholderText="Start"
                        className="form-control form-control-sm"
                        dateFormat="dd/MM/yy"
                        isClearable
                      />
                    </div>

                    {/* End Date */}
                    <div className="col-6 col-md-2">
                      <small className="d-block mb-1">End</small>
                      <DatePicker
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        placeholderText="End"
                        className="form-control form-control-sm"
                        dateFormat="dd/MM/yy"
                        isClearable
                      />
                    </div>

                    {/* Limit */}
                    <div className="col-6 col-md-2">
                      <small className="d-block mb-1">Show</small>
                      <select
                        className="form-control form-control-sm"
                        value={limit}
                        onChange={(e) => {
                          setLimit(Number(e.target.value));
                          currentPage.current = 1;
                        }}
                      >
                        <option value="10">10</option>
                        <option value="30">30</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                    </div>

                    {/* Status */}
                    <div className="col-6 col-md-2">
                      <small className="d-block mb-1">Status</small>
                      <select
                        className="form-control form-control-sm"
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                      >
                        <option value="all">All</option>
                        <option value="paid">Paid</option>
                        <option value="pending">Pending</option>
                        <option value="reject">Reject</option>
                      </select>
                    </div>

                    {/* Reset */}
                    <div className="col-6 col-md-1 d-flex align-items-end">
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={clearFilters}
                      >
                        Reset
                      </button>
                    </div>

                  </div>
                </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-bordered table-hover">
                    <thead className="thead-dark">
                      <tr>
                        <th className="text-nowrap">#</th>
                        <th className="text-nowrap">From</th>
                        <th className="text-nowrap">Amount </th>
                        <th className="text-nowrap">Bonus </th>
                        <th className="text-nowrap">ORDER ID</th>
                        <th className="text-nowrap">GATEWAY</th>
                        <th className="text-nowrap">Date</th>
                        <th className="text-nowrap">Status</th>
                        <th className="text-nowrap">Agent ID</th>
                        <th className="text-nowrap">Wallet Type</th>
                        <th className="text-nowrap">Promotion</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.length === 0 ? (
                        <tr>
                          <td colSpan="11" className="text-center text-muted py-4">
                            No records found
                          </td>
                        </tr>
                      ) : (
                        data.map((deposit, index) => (
                          <tr key={deposit._id || index}>
                            <td>{(currentPage.current - 1) * limit + index + 1}</td>
                            <td className="text-nowrap">{deposit.user_id}</td>

                            <td className="text-nowrap">
                              ৳{parseFloat(deposit.send_amount).toLocaleString('en-US')}
                            </td>

                            <td className="text-nowrap">
                              ৳{parseFloat(deposit.send_amount_in_bdt - deposit.send_amount).toLocaleString('en-US')}
                            </td>

                            <td className="text-nowrap">{deposit.trxid}</td>
                            <td className="text-nowrap">{deposit.selected_method}</td>
                            <td className="text-nowrap">{formatDate(deposit.createdAt)}</td>
                            <td>
                              {deposit.status === 'paid' ? (
                                <span className="badge badge-success">Paid</span>
                              ) : deposit.status === 'reject' ? (
                                <span className="badge badge-danger">Rejected</span>
                              ) : (
                                <span className="badge badge-warning">Pending</span>
                              )}
                            </td>
                            <td className="text-nowrap">{deposit.agent_id}</td>
                            <td className="text-nowrap">{deposit.wallet_type}</td>
                            <td className="text-nowrap">
                              {deposit.promotion_details
                                ? `${deposit.promotion_details.promotionName} (Bonus: ৳${deposit.promotion_details.bonusAmount})`
                                : "No Promotion"}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                    <tfoot>
                      <tr className="table-secondary">
                        <td colSpan="2"><strong>Total (filtered)</strong></td>
                        <td><strong>৳{totalAmount.toLocaleString('en-US')}</strong></td>
                        <td><strong>৳{totalBonus.toLocaleString('en-US')}</strong></td>
                        <td colSpan="7"></td>
                      </tr>
                    </tfoot>
                  </table>

                  <MyPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    marginPagesDisplayed={2}
                    containerClassName="pagination justify-content-center"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    activeClassName="active"
                    forcePage={currentPage.current - 1}
                  />
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Daily_deposit;